import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdsComponent } from '../wifi/ads/ads.component';
import { RutasComponent } from './rutas/rutas.component';
import { UnidadesComponent } from './unidades/unidades.component';
import { RouterosBoxesComponent } from './routeros-boxes/routeros-boxes.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'Boxes',
        pathMatch: 'full'
    },
    {
        path: 'rutas',
        component: RutasComponent,
        data: {
            title: 'Rutas'
        }
    },
{
  path: 'boxes',
  component: RouterosBoxesComponent,
  data: { title: 'Boxes' }
},

    {
        path: 'unidades',
        component: UnidadesComponent,
        data: {
            title: 'Unidades'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AdministrationRoutingModule { }
